import { useTranslation } from 'react-i18next';
import PageHeader from 'components/pageHeader/PageHeader';
import CalendarImportSection from './sections/calendarImport/CalendarImportSection';
import CalendarExportSection from './sections/calendarExport/CalendarExportSection';
import { CalendarToolsTabContainer } from './CalendarToolsTab.styles';

const CalendarToolsTab = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('pageAutomations.calendarTools.title')} noDivider />
      <CalendarToolsTabContainer>
        <CalendarImportSection />
        <CalendarExportSection />
      </CalendarToolsTabContainer>
    </>
  );
};

export default CalendarToolsTab;
